/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect } from "react";
import { connect } from "react-redux";

//table imports
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";

//icons
import Delete from "@mui/icons-material/Delete";

import { withTranslation } from "react-i18next";

import { Grid } from "@mui/material";
import Input from "../../../component/inputpm";
import { Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";
import moveUp from "../../../asset/images/moveUp.png";
import moveDown from "../../../asset/images/moveDown.png";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

const AssemblyInstructions = (props) => {
  useEffect(() => {});
  const t = props.t;
  return (
    <React.Fragment>
      <Grid container>
        {props.readonly ? (
          ""
        ) : (
          <>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <Input
                name={"name"}
                value={props.data.routing.name}
                onChange={(event) => props.onChangeRoutingData(event)}
                placeholder={t("TITLE")}
                disabled={props.readonly}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 6,
              }}
            ></Grid>
            <Grid
              item
              style={{ marginTop: 15 }}
              size={{
                xs: 6,
              }}
            >
              <Input
                name={"description"}
                value={props.data.routing.description}
                onChange={(event) => props.onChangeRoutingData(event)}
                inputProps={{ rows: 2, cols: 31 }}
                placeholder={t("DESCRIPTION")}
                multiline={true}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 6,
              }}
            ></Grid>
            {/* <Grid item xs={6}>
                    <b>{t('ASSEMBLY_TASKS_TITLE')}</b>
                </Grid> */}
            <Grid
              item
              align="left"
              style={{ marginTop: 15 }}
              size={{
                xs: 12,
              }}
            >
              <span
                onClick={(e) => {
                  props.addInstruction();
                }}
                style={{ position: "relative", top: "-7px", cursor: "pointer" }}
              >
                {t("ADD_TASK")} &nbsp;
              </span>
              <Tooltip title="Add Task">
                <IconButton
                  color="primary"
                  aria-label="Add Task"
                  component="span"
                  onClick={(e) => {
                    props.addInstruction();
                  }}
                  style={{
                    color: "#000",
                    paddingTop: 0,
                    paddingBottom: 0,
                    fontSize: 16,
                  }}
                >
                  <AddCircleOutlineIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </>
        )}
        <Grid
          item
          style={{ marginTop: 15 }}
          size={{
            xs: 12,
          }}
        >
          <TableContainer>
            <Table size="small" aria-label="purchases">
              <TableHead>
                <TableRow>
                  <TableCell align="left">{t("TASK_NAME")}</TableCell>
                  <TableCell align="left">
                    <b>{t("DESCRIPTION")}</b>
                  </TableCell>
                  <TableCell align="center" style={{ width: "120px" }}>
                    <b>
                      {t("ESTIMATED_TIME")} ({t("IN_SECONDS")})
                    </b>
                  </TableCell>
                  <TableCell align="center">
                    <b>{t("ACTION")}</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.data.routing.routingTasks &&
                  props.data.routing.routingTasks.length > 0 &&
                  props.data.routing.routingTasks.map((opt, itemIndex) => (
                    <React.Fragment key={itemIndex}>
                      <TableRow>
                        <TableCell align="left">
                          <Input
                            name={"name"}
                            value={opt.name}
                            onChange={(event) =>
                              props.onInstructionChange(event, itemIndex)
                            }
                            disabled={props.readonly}
                          />
                        </TableCell>
                        <TableCell align="left">
                          <Input
                            name={"description"}
                            value={opt.description}
                            onChange={(event) =>
                              props.onInstructionChange(event, itemIndex)
                            }
                            inputProps={{ rows: 1, cols: 31 }}
                            disabled={props.readonly}
                            multiline={true}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Input
                            name={"estimatedCompletionTimeInSeconds"}
                            value={opt.estimatedCompletionTimeInSeconds}
                            onChange={(event) =>
                              props.onInstructionChange(event, itemIndex)
                            }
                            style={{ width: "120px" }}
                            disabled={props.readonly}
                          />
                        </TableCell>
                        <TableCell>
                          <TableContainer>
                            <Table style={{ margin: "auto" }}>
                              <TableBody>
                                <TableRow>
                                  <TableCell style={{ padding: 0 }}>
                                    {props.readonly ? (
                                      ""
                                    ) : (
                                      <Tooltip
                                        title={props.t("DELETE")}
                                        style={{ marginRight: "5px" }}
                                      >
                                        <Delete
                                          onClick={() => {
                                            props.removeInstruction(itemIndex);
                                          }}
                                        />
                                      </Tooltip>
                                    )}
                                  </TableCell>
                                  <TableCell style={{ padding: 0 }}>
                                    {props.readonly ? (
                                      ""
                                    ) : (
                                      <>
                                        {props.data.routing.routingTasks
                                          .length > 1 && (
                                          <>
                                            {itemIndex !== 0 && (
                                              <Tooltip title={t("MOVE_UP")}>
                                                <img
                                                  src={moveUp}
                                                  style={{
                                                    cursor: "pointer",
                                                    opacity: "80%",
                                                    height: "24px",
                                                  }}
                                                  onClick={() =>
                                                    props.changeInstructionSequence(
                                                      "up",
                                                      itemIndex,
                                                    )
                                                  }
                                                />
                                              </Tooltip>
                                            )}
                                            {itemIndex + 1 !==
                                              props.data.routing.routingTasks
                                                .length && (
                                              <Tooltip title={t("MOVE_DOWN")}>
                                                <img
                                                  src={moveDown}
                                                  style={{
                                                    cursor: "pointer",
                                                    marginLeft: 5,
                                                    opacity: "80%",
                                                    height: "24px",
                                                  }}
                                                  onClick={() =>
                                                    props.changeInstructionSequence(
                                                      "down",
                                                      itemIndex,
                                                    )
                                                  }
                                                />
                                              </Tooltip>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                {props.data.routing.routingTasks &&
                  props.data.routing.routingTasks.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        {t("NO_INSTRUCTIONS_ADDED")}
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps)(
  withTranslation("translations")(AssemblyInstructions),
);
